module.exports = __webpack_public_path__ + "static/2-8e512d108844eab1bf0bec3a2eb5ac01.jpg";